import { BODY_PARTS_FOR_HUMANS, InsulinBodyPart, InsulinType, SIDES_FOR_HUMANS, } from "@madmedical/medical";
export const formatAdministrationSide = (side) => {
    switch (side) {
        case "left":
            return "Bal";
        case "right":
            return "Jobb";
    }
};
export const formatAdministrationSideBracket = (side) => {
    switch (side) {
        case "left":
            return "(bal)";
        case "right":
            return "(jobb)";
    }
};
export const formatInsertPoint = (part, side) => {
    const formattedSide = side ? formatAdministrationSideBracket(side) : "";
    switch (part) {
        case InsulinBodyPart.Arm:
            return "Kar " + formattedSide;
        case InsulinBodyPart.Thigh:
            return "Láb " + formattedSide;
        case InsulinBodyPart.Abdomen:
            return "Has " + formattedSide;
        case InsulinBodyPart.Glutes:
            return "Fenék " + formattedSide;
        case InsulinBodyPart.Waist:
            return "Derék " + formattedSide;
    }
};
export const formatType = (type) => {
    switch (type) {
        case InsulinType.Basal:
            return "Hosszú hatású";
        case InsulinType.Rapid:
            return "Gyors hatású";
        case InsulinType.Other:
            return "Egyéb";
    }
};
const bodyParts = Object.values(InsulinBodyPart);
const side = ["left", "right"];
export const generateInsulinBodyLocations = () => {
    const insulinBodyLocations = [];
    bodyParts.forEach((bodyPart) => {
        side.forEach((side) => {
            insulinBodyLocations.push({
                value: `${bodyPart}-${side}`,
                label: `${BODY_PARTS_FOR_HUMANS[bodyPart]} (${SIDES_FOR_HUMANS[side]})`,
            });
        });
    });
    return insulinBodyLocations;
};
